module.exports = "/_next/static/images/Joseph_DiMelis-6756ebf3680018b5515e4152834cb437.webp";